import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingInfoMobile } from '../../components/NewbuildingInfo';
import { selectTotalImagesCount } from '../../selectors/constructionProgress';
import { selectNewbuilding } from '../../selectors/newbuilding';
import { trackAboutNewbuildingTagClick } from '../../utils/analytics';

import { ProblemChoicePopupContainer } from '../ProblemChoicePopup';
import { ReliableChoicePopupContainer } from '../ReliableChoicePopup';

import { getAboutNewbuildingLink, getNewbuildingStatuses } from './helpers';
import { FavoriteButtonMobileWithMotivation } from './parts/FavoriteButtonMobileWithMotivation';

export const NewbuildingInfoMobileContainer: React.VFC = () => {
  const newbuilding = useSelector(selectNewbuilding);
  const totalImagesCount = useSelector(selectTotalImagesCount);

  const newbuildingInfo = React.useMemo(
    () => ({
      aboutLink: getAboutNewbuildingLink(newbuilding.url),
      statuses: getNewbuildingStatuses(newbuilding, totalImagesCount),
    }),
    [newbuilding, totalImagesCount],
  );

  return (
    <NewbuildingInfoMobile
      favoriteButton={<FavoriteButtonMobileWithMotivation />}
      problemLabel={<ProblemChoicePopupContainer />}
      reliableLabel={<ReliableChoicePopupContainer />}
      builderName={newbuilding.builderInfo?.name}
      newbuildingName={newbuilding.name}
      housesByTurn={newbuilding.housesByTurnDisplay}
      statuses={newbuildingInfo.statuses}
      url={newbuildingInfo.aboutLink}
      onLinkClick={trackAboutNewbuildingTagClick}
    />
  );
};
